import type { CustomDomainDnsRecord } from "../../../shared/customDomains";
import type { CustomDomainSetup } from "../../../shared/generatedDrizzleSchema";
import { useFormatRelativeTime } from "../../hooks/useFormatRelativeTime";
import { StatusPill } from "../StatusPill";
import { Text } from "../Text";
import {
  attentionMessage,
  finishingSetup,
  recordBadge,
  statusBadge,
} from "./status";

export function DomainStatusPill({
  setup,
  record,
}: {
  setup: CustomDomainSetup;
  record?: CustomDomainDnsRecord;
}) {
  const formatRelativeTime = useFormatRelativeTime();
  const { label, color } = record
    ? recordBadge(setup, record)
    : statusBadge(setup);
  const checking = !!setup.managed && setup.lastCheckedAt === null;
  const finishing = finishingSetup(setup);
  const detail = checking
    ? "Checking DNS…"
    : (attentionMessage(setup) ??
      (finishing
        ? "All records found. We’re verifying the domain and issuing its HTTPS certificate. This usually takes a few minutes."
        : setup.status !== "ready" && setup.lastCheckedAt
          ? `DNS last checked ${formatRelativeTime(setup.lastCheckedAt)}`
          : "Ready to use."));
  return (
    <StatusPill
      passive
      running={!record && finishing}
      color={color}
      label={label}
      detail={
        <Text variant="text-small-md" color="var(--tooltip-fg)">
          {detail}
        </Text>
      }
      compactIcon={
        color === "green" ? "check" : color === "red" ? "x" : "circle-dashed"
      }
    />
  );
}
